import { useAtomValue } from 'jotai';
import React from 'react';

import {
  ActionComponent as ActionComponentType,
  ActionComponentStateConfig,
  DisplayRefDisplayType,
} from '@repo/sdk/models/components';

import { ActionComponent } from '@/features/equipment-browser/action-components/action-component';
import { getActiveState } from '@/features/equipment-browser/conditional-evaluator/get-active-state';
import { equipmentResponseAtom } from '@/features/equipment-browser/equipment-details/state/equipment-response.state';
import { useGetReadingsValues } from '@/features/equipment-browser/subscriptions/use-get-readings-values';
import { useGetSettingsValues } from '@/features/equipment-browser/subscriptions/use-get-settings-values';
import { extractActionComponentRefs } from '@/helpers/extract-refs';

export const EquipmentDetailsActions = (): React.ReactNode => {
  const equipment = useAtomValue(equipmentResponseAtom);
  const actionComponents = equipment?.actionComponents;

  useGetReadingsValues(
    extractActionComponentRefs(actionComponents ?? [], false).map(
      (ref) => ({
        displayType: DisplayRefDisplayType.Label,
        label: '',
        ref,
      }),
      'actionComponentReadings'
    )
  );

  useGetSettingsValues(
    extractActionComponentRefs(actionComponents ?? [], true).map(
      (ref) => ({
        displayType: DisplayRefDisplayType.Label,
        label: '',
        ref,
      }),
      'actionComponentSettings'
    )
  );

  if (!actionComponents || actionComponents.length === 0) {
    return null;
  }

  return (
    <>
      {(actionComponents || [])
        .filter((actionComponent: ActionComponentType) => actionComponent.states.length > 0)
        .map((actionComponent: ActionComponentType, index: number) => {
          const activeState = getActiveState<ActionComponentStateConfig>({
            states: actionComponent.states,
          });
          // Don't render anything if no state is active
          if (!activeState) {
            return null;
          }
          return (
            <ActionComponent
              key={`action-state-${index}-${activeState.stateName}`}
              state={activeState}
            />
          );
        })}
    </>
  );
};
